export default __webpack_public_path__ + "static/AI_and_MAnufacturuning_Industries_Croped-0b08a366a35870d4ea7c7fbd674fdfe6.jpg";